import { BaseRestRepository } from '~/repositories/baseRestRepository';

export type GetInvoicesParams = {
  from?: string;
  to?: string;
};

export class CompanyBusinessInfoRepository extends BaseRestRepository {
  private readonly BASE_URL = '/api/business-info';

  getBusinessInfoList = async (): Promise<MagicDoor.Api.CompanyBusinessInfoDto[]> => {
    const url = this.BASE_URL;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  };

  createBusinessInfo = async (data: MagicDoor.Api.CreateCompanyBusinessInfoDto): Promise<MagicDoor.Api.CompanyBusinessInfoDto> => {
    const url = this.BASE_URL;
    const response = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify(data) });
    return this.getJsonResponse(response);
  };

  updateBusinessInfo = async (
    id: string,
    data: MagicDoor.Api.UpdateCompanyBusinessInfoDto
  ): Promise<MagicDoor.Api.CompanyBusinessInfoDto> => {
    const url = this.BASE_URL + `/${id}`;
    const response = await this.fetchWithAuth(url, { method: 'PUT', body: JSON.stringify(data) });
    return this.getJsonResponse(response);
  };

  setPrimaryBusinessInfo = async (id: string): Promise<MagicDoor.Api.CompanyBusinessInfoDto> => {
    const url = this.BASE_URL + `/primary`;
    const response = await this.fetchWithAuth(url, { method: 'PATCH', body: JSON.stringify({ businessInfoId: id }) });
    return this.getJsonResponse(response);
  };
}

export const companyBusinessInfoRepository = new CompanyBusinessInfoRepository();
